import { NgIf } from '@angular/common';
import { JsonpClientBackend } from '@angular/common/http';
import { Component, OnInit, inject } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { AppGeneralStateService } from 'src/app/app-general-state.service';
import { DataService } from 'src/app/core/services/data/data.service';
import { LotService } from 'src/app/core/services/data/lot.service';
import { ActiveTaxList } from 'src/app/shared/entities/ActiveTaxList';
import { RevenueTypes } from 'src/app/shared/entities/RevenueTypes';
import { ILotInvoiceMiSettingsResponse } from 'src/app/shared/interfaces';
import { JsonPipe } from '@angular/common';

@Component({
  selector: 'app-tax-applied-checkbox-sandbox',
  standalone: true,
  imports: [
    MatCheckboxModule,
    MatFormFieldModule,
    MatSelectModule,
    MatOptionModule,
    ReactiveFormsModule,
    NgIf,
    JsonPipe,
  ],
  templateUrl: './tax-applied-checkbox-sandbox.component.html',
  styleUrl: './tax-applied-checkbox-sandbox.component.scss',
})
export class TaxAppliedCheckboxSandboxComponent implements OnInit {
  allRevenueTypes: RevenueTypes[] = [];
  filteredRevenueTypes: RevenueTypes[] = [];
  activeTaxListForLot: ActiveTaxList[] = [];
  currentLotNumber: string = '';
  newMiInvoiceSettings: ILotInvoiceMiSettingsResponse | undefined = undefined;
  taxIsNotApplicable: boolean = true;
  checkboxText: string = 'Tax Applied?';
  selectedRevenueData: RevenueTypes | null = null;

  invoiceLineForm = new FormGroup({
    revenueCode: new FormControl('', [Validators.required]),
    isTaxable: new FormControl({ value: true, disabled: true }, []),
  });

  _appGeneralState = inject(AppGeneralStateService);
  _lotService = inject(LotService);
  _dataService = inject(DataService);

  constructor() {
    this.currentLotNumber = this._appGeneralState.currentLotNumber;
  }

  ngOnInit(): void {
    this.getMiInvoiceCreationSettings(this._appGeneralState.currentLotNumber);
    this.getRevenueTypesForLotNumber(this._appGeneralState.currentLotNumber);
    this.getActiveTaxListForLotNumber(this._appGeneralState.currentLotNumber);

    this.invoiceLineForm.get('revenueCode')?.valueChanges.subscribe(() => this.onChangeRevenueType());

    this._appGeneralState.lotNumberSubject.subscribe({
      next: (v) => this.onLotNumberChange(v),
    });

    this.onTestNoTax();
  }
  onEvalTaxApplied(): void {}

  onCalculateRateData(): void {}

  onTestNoTax(): void {
    this.taxIsNotApplicable = true;
    this.checkboxText = 'Tax Not Applicable';
    this.updateTaxableControlState();
  }

  onLotNumberChange(newLotNumber: string): void {
    this.currentLotNumber = newLotNumber;

    this.invoiceLineForm.reset({
      revenueCode: '',
      isTaxable: true,
    });
    this.invoiceLineForm.get('isTaxable')?.disable({ emitEvent: false });

    this.getMiInvoiceCreationSettings(newLotNumber);
    this.getRevenueTypesForLotNumber(newLotNumber);
    this.getActiveTaxListForLotNumber(newLotNumber);
  }

  onChangeRevenueType(): void {
    this.updateTaxableControlState();

    this.onCalculateRateData();

    this.selectedRevenueData =
      this.allRevenueTypes.find((rev) => rev.code === this.invoiceLineForm.get('revenueCode')?.value) ?? null;
  }

  updateTaxableControlState(): void {
    const revCode: string = this.invoiceLineForm.get('revenueCode')?.value ?? '';
    const isTaxableControl = this.invoiceLineForm.get('isTaxable');

    if (this.taxIsNotApplicable || revCode == '') {
      isTaxableControl?.disable({ emitEvent: false });
      return;
    }

    isTaxableControl?.enable({ emitEvent: false });
  }

  getMiInvoiceCreationSettings(lotNumber: string): void {
    this._dataService.getLotMiInvoiceSettings(lotNumber).subscribe({
      next: (res) => {
        this.newMiInvoiceSettings = res;
      },
      error: (_err: any) => {},
      complete: () => {
        this.configureFilteredRevenueTypes();
      },
    });
  }

  getRevenueTypesForLotNumber(lotNumber: string): void {
    this._lotService.getRevenueTypesForLotNumber(lotNumber).subscribe({
      next: (res) => {
        this.allRevenueTypes = res;
      },
      error: (_err: any) => {
        this.allRevenueTypes = [];
      },
      complete: () => {
        this.configureFilteredRevenueTypes();
      },
    });
  }

  configureFilteredRevenueTypes(): void {
    let ii: number = 0;
    this.filteredRevenueTypes = [];

    if (this.newMiInvoiceSettings == undefined) {
      this.filteredRevenueTypes = this.allRevenueTypes;
      return;
    }

    if (this.newMiInvoiceSettings.allowMonthlyParkerRevenueCodes == false) {
      for (ii = 0; ii < this.allRevenueTypes.length; ii++) {
        if (false == this.allRevenueTypes[ii].description.toUpperCase().includes('MONTH')) {
          this.filteredRevenueTypes.push(this.allRevenueTypes[ii]);
        }
      }
      return;
    }

    this.filteredRevenueTypes = this.allRevenueTypes;
  }

  getActiveTaxListForLotNumber(lotNumber: string) {
    this._lotService.getActiveTaxListByLotNumber(lotNumber).subscribe(
      (res) => {
        this.activeTaxListForLot = res;
      },
      (err: any) => {},
      () => {},
    );
  }
}
